/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_budget_unlock_tier_a_desc_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See price change probabilities for top drivers.`)
};

const es_f1_budget_unlock_tier_a_desc_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mira las probabilidades de cambio de precio de los pilotos top.`)
};

const de_f1_budget_unlock_tier_a_desc_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sieh Preisänderungswahrscheinlichkeiten für Top-Fahrer.`)
};

const nl_f1_budget_unlock_tier_a_desc_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk prijswijzigingskansen voor topcoureurs.`)
};

const fr_f1_budget_unlock_tier_a_desc_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voyez les probabilités de changement de prix pour les meilleurs pilotes.`)
};

const it_f1_budget_unlock_tier_a_desc_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri le probabilità di variazione prezzo per i piloti top.`)
};

const pt_br2_f1_budget_unlock_tier_a_desc_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja probabilidades de mudança de preço para pilotos de ponta.`)
};

const pt_f1_budget_unlock_tier_a_desc_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja as probabilidades de alteração de preço para pilotos de topo.`)
};

const ja_f1_budget_unlock_tier_a_desc_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トップドライバーの価格変動確率を確認。`)
};

const zh_f1_budget_unlock_tier_a_desc_drivers = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看顶级车手的价格变动概率。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_budget_unlock_tier_a_desc_drivers = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_budget_unlock_tier_a_desc_drivers(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_budget_unlock_tier_a_desc_drivers", locale)
	if (locale === "en") return en_f1_budget_unlock_tier_a_desc_drivers(inputs)
	if (locale === "es") return es_f1_budget_unlock_tier_a_desc_drivers(inputs)
	if (locale === "de") return de_f1_budget_unlock_tier_a_desc_drivers(inputs)
	if (locale === "nl") return nl_f1_budget_unlock_tier_a_desc_drivers(inputs)
	if (locale === "fr") return fr_f1_budget_unlock_tier_a_desc_drivers(inputs)
	if (locale === "it") return it_f1_budget_unlock_tier_a_desc_drivers(inputs)
	if (locale === "pt-BR") return pt_br2_f1_budget_unlock_tier_a_desc_drivers(inputs)
	if (locale === "pt") return pt_f1_budget_unlock_tier_a_desc_drivers(inputs)
	if (locale === "ja") return ja_f1_budget_unlock_tier_a_desc_drivers(inputs)
	return zh_f1_budget_unlock_tier_a_desc_drivers(inputs)
};